export class Content {
  id: number;
  textFr: string;
  textDe: string;
  textEn: string;
}
